import React from 'react'
import { makeStyles } from '@mui/styles'
import Typography from '@mui/material/Typography'

const useStyles = makeStyles((theme) => ({
  title: {
    fontWeight: 'bold',
    fontSize: 20,
    color: '#1A1A1A',
    marginBottom: 10,
  },
}))

const H3Title = ({ children, className = '', ...props }) => {
  const classes = useStyles()
  return (
    <Typography id="step-title" variant="h6" className={`${classes.title} ${className}`} {...props}>
      {children}
    </Typography>
  )
}

export default H3Title
